(function(_){
    'use strict';

    _['TRIPADVISOR.NO-CONTENT']=  'não há conteúdo neste módulo';

}(translations['pt']));


// WEBPACK FOOTER //
// ./src/app/modules/tripadvisor/lang/tripadvisor-lang_pt.js